import React from "react"
import UsersList from "./UsersList"
import UserForm from "./UserForm"
import withHooks from "../../Common/jsx/WithHooks"
import { strToUpperSnakeCase } from "../../Common/js/string_utils"

class UsersManager extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.debug("const_props:", this.props)

    this.entityType = "user"
    this.entitiesType = "users"

    this.state = {
      pageType: this.props.pageType,
    }
    this.dMgr.debug("init_state:", this.state)
  }

  render() {
    this.dMgr.rendering()

    let toRender
    if (this.state.pageType === "list") {
      this.dMgr.debug("toRender:", "list")

      if (!this.props.RightsManager.userHasRight(strToUpperSnakeCase(this.entityType) + ":VIEW_COLLECTION")) {
        console.log("ACCESS DENIED TO " + this.entityType)
        window.location = "/"
        return null
      }

      toRender = <UsersList entityType={this.entityType} entitiesType={this.entitiesType} goTo={(pageName) => this.setState({ pageType: pageName })} />
    } else if (this.state.pageType === "form") {
      this.dMgr.debug("toRender:", "form", "entityId:", this.props.entityId)

      if (!this.props.RightsManager.userHasRight(strToUpperSnakeCase(this.entityType) + ":EDIT")) {
        console.log("ACCESS DENIED TO " + this.entityType)
        window.location = "/"
        return null
      }

      toRender = <UserForm entityType={this.entityType} entitiesType={this.entitiesType} goTo={(pageName) => this.setState({ pageType: pageName })} entityId={this.props.entityId} />
    }

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(UsersManager)
